import { VACANCY_FILTER_KEYS } from "./constants";

import { URL_PARAMS } from "@/constants/urlParams";
import { clearFilterValues, removeFilterValue } from "@/lib/utils/filterParams";

const withoutPage = (params: URLSearchParams) => {
  params.delete(URL_PARAMS.PAGE);
  return params;
};

export const withoutVacancyFilter = (
  params: URLSearchParams,
  key: string,
  value: string,
) => withoutPage(removeFilterValue(params, key, value));

export const withoutVacancyFilters = (params: URLSearchParams) =>
  withoutPage(clearFilterValues(params, [...VACANCY_FILTER_KEYS]));
